import { render } from "./CalledsForm.vue?vue&type=template&id=20218dc6&scoped=true"
import script from "./CalledsForm.vue?vue&type=script&lang=js"
export * from "./CalledsForm.vue?vue&type=script&lang=js"

import "./CalledsForm.vue?vue&type=style&index=0&id=20218dc6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20218dc6"]])

export default __exports__